import { NgModule } from '@angular/core';
import { CommonModule, DatePipe } from '@angular/common';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { FrontRoutingModule } from './front-routing.module';
import { GraphQLModule } from '../graphql.module';
import { SharedModuleModule } from './shared-module/shared-module.module';
import { PagesModule } from '../front/page/pages.module';
import { AdminModule } from './admin/admin.module';



@NgModule({
  declarations: [
    
  ],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    FrontRoutingModule,
    GraphQLModule,
    PagesModule,
    SharedModuleModule,
    AdminModule,
   
  ],
  providers:[DatePipe]
})
export class FrontModule { }
